import {
  BidImage,
  DashboardImage,
  ProcurementImage,
  QualityManagementImage,
  VerifiedVendorImage,
} from "assets/images";
import { Feature } from "components/containers/constant";

const features: Feature[] = [
  {
    name: "Dashboard",
    image: DashboardImage,
    description:
      "Deploy capital to build projects, with tools that lower risk, increase efficiency, enhance oversight, and ensure stakeholder accountability.",
  },
  {
    name: "Bid",
    image: BidImage,
    description:
      "Get access to a steady flow of projects to bid for and submit your bids online in a transparent process. All for free.",
  },
  {
    name: "Procurement Management",
    image: ProcurementImage,
    description:
      "Get granular details of material procurement and consumption on projects.",
  },
  {
    name: "Quality Management",
    image: QualityManagementImage,
    description:
      "Our robust check-listing feature ensures that all tasks are delivered to the right quality specification.",
  },
  {
    name: "Verified Vendors",
    image: VerifiedVendorImage,
    description:
      "Go through our simple vetting process and receive our verification mark that project owners trust..",
  },
];

let tabsforContractors = [
  "One dashboard",
  "Zero tender fees",
  "Access vendors",
  "Real time tracking",
  "Get verified",
];

let tabsforUsers = [
  "Verified professionals",
  "Transparent bid process",
  "Project Clarity",
  "Secured Capital",
  "Real-time Tracking",
];

export { tabsforContractors, tabsforUsers, features };
